export default __webpack_public_path__ + "static/media/tw.d663c6ca.svg";